<template>
    <div class="product-image" :class="[className, {'loading': !isLoaded}]" ref="productImage">
        <img :data-src="image.src" :alt="image.alt" :class="image.class" @load="onImgLoad" :data-width="image.width" />
    </div>
</template>

<script src="./product-image.js"></script>
